module.exports = __webpack_public_path__ + "static/media/illustration-element-07.b6de7bae.svg";